import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { ValuesMap } from '@/common/types';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'GET_ALLOWED_COUNTRIES';
interface CountryPayload {
  id: number;
  alpha2: string;
  alpha3: string;
  name: string;
  us_postal: string;
}

const EXCLUDED_COUNTRIES = ['RAL', 'UNK'];

export default () => {
  const { isLoading, data, isSuccess } = useQuery([QUERY_KEY], () =>
    api.get<CountryPayload[]>(API_URL.COUNTRIES)
  );
  const allowedCountriesMap = useMemo(
    () =>
      data?.data.reduce((result: ValuesMap<boolean>, item) => {
        if (EXCLUDED_COUNTRIES.includes(item.alpha3)) {
          return result;
        }
        result[item.alpha2] = true;

        return result;
      }, {}),
    [data]
  );
  return {
    allowedCountriesMap,
    isLoading,
    isSuccess,
  };
};
